export class SliderElement {
    id;
    numberInputWrapper;
    numberInputMinContainer;
    numberInputMin;
    numberInputMinLabel;
    numberInputMaxContainer;
    numberInputMax;
    numberInputMaxLabel;
    rangeInputWrapper;
    inverseLeft;
    range;
    inverseRight;
    thumbMin;
    thumbMax;
    rangeInputMin;
    rangeInputMax;
    constructor(id, numberInputWrapper, numberInputMinContainer, numberInputMin, numberInputMinLabel, numberInputMaxContainer, numberInputMax, numberInputMaxLabel, rangeInputWrapper, inverseLeft, range, inverseRight, thumbMin, thumbMax, rangeInputMin, rangeInputMax) {
        this.id = id;
        this.numberInputWrapper = numberInputWrapper;
        this.numberInputMinContainer = numberInputMinContainer;
        this.numberInputMin = numberInputMin;
        this.numberInputMinLabel = numberInputMinLabel;
        this.numberInputMaxContainer = numberInputMaxContainer;
        this.numberInputMax = numberInputMax;
        this.numberInputMaxLabel = numberInputMaxLabel;
        this.rangeInputWrapper = rangeInputWrapper;
        this.inverseLeft = inverseLeft;
        this.range = range;
        this.inverseRight = inverseRight;
        this.thumbMin = thumbMin;
        this.thumbMax = thumbMax;
        this.rangeInputMin = rangeInputMin;
        this.rangeInputMax = rangeInputMax;
    }
    /**
 *
 *
 *
 *
 */
    getNumberInputMinValue() {
        return this.numberInputMin.value === ""
            ? this.numberInputMin.placeholder
            : this.numberInputMin.value;
    }
    getNumberInputMaxValue() {
        return this.numberInputMax.value === ""
            ? this.numberInputMax.placeholder
            : this.numberInputMax.value;
    }
}
